import { Flex, Typography } from "antd";
import { Breadcrumbs } from "components/Breadcrumbs/";
import { useAntTheme } from "hooks/useAntTheme/";
import { CSSProperties } from "react";
import {
  toNegativeCssBox,
  usePagePadding,
} from "components/layout/pagePadding";

export const PageBreadcrumbsHeader = ({
  title,
  subtitle,
  style,
}: {
  title: string;
  subtitle: string;
  style?: CSSProperties;
}) => {
  const { theme } = useAntTheme();
  // Full-bleed bar: cancels the app shell's page padding.
  const pagePadding = usePagePadding();
  return (
    <Flex
      vertical
      style={{
        backgroundColor: theme.colorPrimary,
        width: `calc(100% + ${pagePadding.left + pagePadding.right}px)`,
        maxWidth: "100vw",
        margin: toNegativeCssBox(pagePadding),
        ...style,
      }}
    >
      <div
        style={{
          backgroundColor: theme.colorPrimary,
          padding: "12px 35px",
          borderBottom: `0.3px solid ${theme.colorWhite}`,
        }}
      >
        <Breadcrumbs size={"md"} color={theme.colorBgBase} />
      </div>
      <Flex vertical gap={10} style={{ padding: "14px 35px" }}>
        <Typography.Text
          style={{
            fontSize: 40,
            fontWeight: 500,
            letterSpacing: "-2.2px",
            lineHeight: 0.95,
            color: theme.colorWhite,
          }}
        >
          {title}
        </Typography.Text>
        <Typography.Text
          style={{
            fontSize: 20,
            lineHeight: 1.9,
            letterSpacing: "-1px",
            color: theme.colorWhite,
          }}
        >
          {subtitle}
        </Typography.Text>
      </Flex>
    </Flex>
  );
};
